'use client';

import { Suspense } from 'react';

import { ACCOUNT_COPY } from '@eliadmin/core/src/components/dlz/account/account-copy';
import { AccountHeading } from '@eliadmin/core/src/components/dlz/account/account-heading';
import { ProfileForm } from '@eliadmin/core/src/components/dlz/account/profile/profile-form';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

/**
 * „Môj profil“ (Figma 60321:19067, mobile 60459:88651): heading, then the profile form 24 px below.
 * The column is the container of the two-column rows (877 px at 1728, 509 px beside the navigation
 * at 1024), so they follow its width rather than the viewport. The form waits for the countries.
 */
export function ProfileView() {
  const me = useCustomerStore(s => s.me);
  if (!me) return null;

  return (
    <div className="flex flex-col gap-6 @container">
      <AccountHeading
        title={ACCOUNT_COPY.pages.profile.label}
        description={ACCOUNT_COPY.pages.profile.description}
      />
      <Suspense fallback={<GenericLoader className="h-[40vh]" />}>
        <ProfileForm customer={me.customer} authToken={me.authToken} />
      </Suspense>
    </div>
  );
}
